module.exports = __webpack_public_path__ + "img/mic16.b94fee55.jpg";